import { Component, OnInit, OnDestroy } from '@angular/core';
import VehiclePolicy from '../../../../core/data/models/vehicle.policy.model';
import HousePolicy from '../../../../core/data/models/house.policy.model';
import TravelPolicy from '../../../../core/data/models/travel.policy.model';
import { Subscription } from 'rxjs/internal/Subscription';
import { PolicyService } from '../../services/policy.service';
import PolicyTypes from '../../../../common/enums/policyTypes';
import { VehicleDetailComponent } from './vehicle-detail/vehicle-detail.component';
import { HouseDetailComponent } from './house-detail/house-detail.component';
import { TravelDetailComponent } from './travel-detail/travel-detail.component';
import { AuthService } from '../../../auth/services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { SwalService } from '../../../../common/services/swal.service';
import { SharedModule } from '../../../../common/shared.module';
import { policyMask } from '../../../../common/constants/masks';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-policy-detail',
  imports: [
    VehicleDetailComponent,
    HouseDetailComponent,
    TravelDetailComponent,
    SharedModule,
  ],
  templateUrl: './policy-detail.component.html',
  styleUrl: './policy-detail.component.css',
})
export class PolicyDetailComponent implements OnInit, OnDestroy {
  policyType: string = '';
  slob: string = '';

  policyNumber: string | null = '';

  isVehicle: boolean = false;
  isHouse: boolean = false;
  isTravel: boolean = false;

  vehiclePolicies!: VehiclePolicy[];
  housePolicies!: HousePolicy[];
  travelPolicies!: TravelPolicy[];

  modalDismissed: Subscription | undefined;
  policyMask = policyMask;

  constructor(
    private authService: AuthService,
    private activatedRouter: ActivatedRoute,
    private swalService: SwalService,
    private policService: PolicyService,
  ) {}

  ngOnInit(): void {
    this.policyNumber =
      this.activatedRouter.snapshot.paramMap.get('policyNumber');
    this.policyType = this.activatedRouter.snapshot.paramMap.get('type') || '';
    this.slob = this.activatedRouter.snapshot.paramMap.get('slob') || '';
    this.getPolicyDetail();
  }

  async getPolicyDetail() {
    this.swalService.showLoading();
    const idNumber = this.authService.user.idTokenClaims?.extension_IdNumber!;

    try {
      switch (this.policyType) {
        case PolicyTypes.Vehicle:
          this.isVehicle = true;
          const vehicleResult = await lastValueFrom(
            this.policService.getVehiclePolicyDetail(
              this.policyNumber!,
              idNumber,
            ),
          );

          this.vehiclePolicies = vehicleResult.data;
          break;

        case PolicyTypes.House:
          this.isHouse = true;
          const houseResult = await lastValueFrom(
            this.policService.getHousePolicyDetail(
              this.policyNumber!,
              idNumber,
            ),
          );

          this.housePolicies = houseResult.data;
          break;

        case PolicyTypes.Travel:
          this.isTravel = true;
          const travelResult = await lastValueFrom(
            this.policService.getTravelPolicyDetail(
              this.policyNumber!,
              idNumber,
            ),
          );

          this.travelPolicies = travelResult.data;
          break;
      }
    } catch (e) {
      console.log('Error getting policy detail: ', e);
    }

    this.swalService.dismiss();
  }

  ngOnDestroy() {
    this.modalDismissed?.unsubscribe();
  }
}
